<app-ledger-sync-spinner></app-ledger-sync-spinner>

<router-outlet></router-outlet>

<app-ledger-sync-notification></app-ledger-sync-notification>
